import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { Subscription } from "rxjs";
import { UserService } from "../../../shared";
import { PersonSelectorService } from "../../personselector/personselector.service";
import { ReportService } from "../../Report/report.service";
import { ReportFileTypeDialogComponent } from "../shared/report-file-type-dialog/report-file-type-dialog.component";
import { DataService_StudentSchedule } from "./shared/data.service";

@Component({
	selector: "app-student-schedule",
	templateUrl: "./student-schedule.component.html",
	styleUrls: ["./student-schedule.component.css"],
})
export class StudentScheduleComponent implements OnInit {
	constructor(
		private userService: UserService,
		private StudentScheduleService: DataService_StudentSchedule,
		private selectService: PersonSelectorService,
		private dialogService: DialogService,
		private reportService: ReportService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.subscription = this.selectService.onPersonSelectChange().subscribe((person) => {
			this.SelectedPerson = person;
			// this.loadSemester();
			// this.loadPeriod();
			// this.loadSchoolDay();
			this.loadSectionScheduleStudent();
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	//Person Selector
	subscription: Subscription;
	SelectedPerson: any;

	isProcessing: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedSectionScheduleStudent: any;
	lstSectionScheduleStudent: any = [];

	//Filter lists
	lstSemester: any = [];
	lstDayDesc: any = [];
	lstPeriodNo: any = [];
	lstPeriodDesc: any = [];
	lstCourseTypeDesc: any = [];
	lstSectionNo: any = [];
	lstRoomNo: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "Semester", header: "Semester" },
		{ field: "DayDesc", header: "Day" },
		{ field: "PeriodNo", header: "Period Number" },
		{ field: "PeriodDesc", header: "Period Description" },
		{ field: "PeriodTimeDesc", header: "Period Time" },
		{ field: "CourseDesc", header: "Course" },
		{ field: "CourseTypeDesc", header: "Course Type" },
		{ field: "SectionNo", header: "Section No" },
		{ field: "TeacherName", header: "Teacher" },
		{ field: "RoomNo", header: "Room No" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadSectionScheduleStudent() {
		this.loading = true;

		if (this.SelectedPerson == undefined) {
			this.loading = false;

			return;
		}

		var result = this.StudentScheduleService.StudentScheduleFullInfoGetList(this.SelectedPerson.PersonID);
		result.subscribe(
			(response) => {
				this.lstSectionScheduleStudent = response;

				//Load Data Filter Lists
				this.lstSemester = Array.from(new Set(this.lstSectionScheduleStudent.map((item: any) => item.Semester))).sort();
				this.lstDayDesc = Array.from(new Set(this.lstSectionScheduleStudent.map((item: any) => item.DayDesc))).sort();
				this.lstPeriodNo = Array.from(new Set(this.lstSectionScheduleStudent.map((item: any) => item.PeriodNo))).sort();
				this.lstPeriodDesc = Array.from(new Set(this.lstSectionScheduleStudent.map((item: any) => item.PeriodDesc))).sort();
				this.lstCourseTypeDesc = Array.from(new Set(this.lstSectionScheduleStudent.map((item: any) => item.CourseTypeDesc))).sort();
				this.lstSectionNo = Array.from(new Set(this.lstSectionScheduleStudent.map((item: any) => item.SectionNo))).sort();
				this.lstRoomNo = Array.from(new Set(this.lstSectionScheduleStudent.map((item: any) => item.RoomNo))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadSectionScheduleStudent();
	}

	//Custom Button Methods
	onPrint() {
		this.errorMessage = "";

		//Error handling

		if (this.SelectedPerson == undefined) {
			this.errorMessage = "Select a person to print demographics";
		}

		var ref = this.dialogService.open(ReportFileTypeDialogComponent, {
			header: "Report File Type",
			width: "fit-content",
			data: {},
		});
		ref.onClose.subscribe((response) => {
			if (response > 0) {
				this.FinishPrint(response);
			}
		});
	}

	FinishPrint(OutputType) {
		//Call SP

		var component = this;
		this.isProcessing = true;

		var strParam = "";

		var Semester = "";
		var Day = "";
		var Period = "";
		var Course = "";
		var CourseType = "";
		var SectionNo = "";
		var Teacher = "";
		var RoomNo = "";

		var SemesterFilter = <HTMLElement>document.getElementById("SemesterFilter").children[0].children[0].children[0];

		if (SemesterFilter.innerText != "Any") {
			Semester = SemesterFilter.innerText;
		}

		var DayFilter = <HTMLElement>document.getElementById("DayFilter").children[0].children[0].children[0];

		if (DayFilter.innerText != "Any") {
			Day = DayFilter.innerText;
		}

		var PeriodFilter = <HTMLElement>document.getElementById("PeriodFilter").children[0].children[0].children[0];

		if (PeriodFilter.innerText != "Any") {
			Period = PeriodFilter.innerText;
		}

		var CourseFilter = <HTMLInputElement>document.getElementById("CourseFilter").children[0].children[0].children[0];
		Course = CourseFilter.value;

		var CourseTypeFilter = <HTMLElement>document.getElementById("CourseTypeFilter").children[0].children[0].children[0];

		if (CourseTypeFilter.innerText != "Any") {
			CourseType = CourseTypeFilter.innerText;
		}

		var SectionNoFilter = <HTMLElement>document.getElementById("SectionNoFilter").children[0].children[0].children[0];

		if (SectionNoFilter.innerText != "Any") {
			SectionNo = SectionNoFilter.innerText;
		}

		var TeacherFilter = <HTMLInputElement>document.getElementById("TeacherNameFilter").children[0].children[0].children[0];
		Teacher = TeacherFilter.value;

		var RoomNoFilter = <HTMLElement>document.getElementById("RoomNoFilter").children[0].children[0].children[0];

		if (RoomNoFilter.innerText != "Any") {
			RoomNo = RoomNoFilter.innerText;
		}

		//Parameter 1: PersonID
		strParam += this.SelectedPerson.PersonID + "|PersonID";

		//Parameter 2: Day
		strParam += "," + Day + "|Day";

		//Parameter 3: Period
		strParam += "," + Period + "|Period";

		//Parameter 4: Semester
		strParam += "," + Semester + "|Semester";

		//Parameter 5: Course
		strParam += "," + Course + "|Course";

		//Parameter 6: CourseType
		strParam += "," + CourseType + "|CourseType";

		//Parameter 7: SectionNo
		strParam += "," + SectionNo + "|SectionNo";

		//Parameter 8: Teacher
		strParam += "," + Teacher + "|Teacher";

		//Parameter 9: RoomNo
		strParam += "," + RoomNo + "|RoomNo";

		var reportID: any = 433;

		//Add type selector

		var result = this.reportService.Print(reportID, strParam, this.SelectedPerson.SchoolID, OutputType);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedSectionScheduleStudent = val.data;
	}
	onRowUnselect(val) {
		this.SelectedSectionScheduleStudent = null;
	}
	////////////////////////////////////////////
}
